export default "__VITE_ASSET__292838bc__"